import React, { Component } from "react";
import { DialogContainer, Button } from "react-md";

export default class BrowserWarning extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { visible: true, showWarning: false };
    this.hide = this.hide.bind(this);
  }
    
  UNSAFE_componentWillMount() {
    // Simple and efficient browser checking.
    let isIE = /*@cc_on!@*/false || !!document.documentMode;
    // var isEdge = !isIE && !!window.StyleMedia;
    // var isFirefox = typeof InstallTrigger !== "undefined";
    // var isOpera = !!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
    // var isChrome = !!window.chrome && !!window.chrome.webstore && navigator.userAgent.toLowerCase().indexOf("googlebot") === -1;
    // var isSafari = !isChrome && navigator.userAgent.toLowerCase().indexOf("safari") !== -1;
    // var isBlink = (isChrome || isOpera) && !!window.CSS;
    // var isGoogleBot = navigator.userAgent.toLowerCase().indexOf("googlebot") !== -1;
    this.setState({showWarning: isIE});
  }
  
  hide() {
    this.setState({ visible: false });
  }

  render() {
    const { visible, showWarning } = this.state;
    if (!showWarning) return null;

    const actions = [<Button key="close" flat primary onClick={this.hide}>Close</Button>];

    return (
      <div>
        <DialogContainer
          id="browser-warning"
          visible={visible}
          title="Unsupported Browser"
          onHide={this.hide}
          aria-describedby="unsupported-browser-warning"
          modal
          actions={actions}
        >
          <p id="browser-warning" className="md-color--secondary-text">
          We have detected that you are using a browser that we do not support.
          <br/>
          <br/>
          We recommend Chrome.
          <br/>
          <br/>
          You may continue using your current browser, but certain features may not opereate correctly.
          </p>
        </DialogContainer>
      </div>
    );
  }
}